var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext } from "react";
import layoutComponentsDictionary from "../../layout/layoutComponentsDictionary";
import { FormSettingsContext } from "../../utils";
import { Select, Option, Input } from "@mui/joy";
import { Spacing } from "../../properties/spacing";
import { Color } from "../../properties/color";
/**
 * Header edit component
 *
 * @param param0
 */
export function HeaderSettings(_a) {
    var isStudioField = _a.isStudioField, layoutType = _a.layoutType, meta = _a.meta;
    var _b = useContext(FormSettingsContext), settings = _b.settings, editedSettings = _b.editedSettings;
    var headerTypes = [
        { type: "h1", label: "Header 1" },
        { type: "h2", label: "Header 2" },
        { type: "h3", label: "Header 3" },
        { type: "h4", label: "Header 4" },
        { type: "h5", label: "Header 5" },
    ];
    var current = settings.currentComponent || {};
    var s = current.settings || {};
    var type = s.type || "";
    var content = s.content || "";
    return (_jsx(_Fragment, { children: _jsxs("div", { children: [_jsxs("div", __assign({ className: "mb-4" }, { children: [_jsx("label", __assign({ className: "block mb-2 font-bold text-gray-700 text-md" }, { children: "Type" })), _jsx(Select, __assign({ className: "w-80 mb-2", size: "md", defaultValue: type, value: type, onChange: function (event, value) {
                                editedSettings(__assign(__assign({}, settings), { component: {
                                        id: settings.target,
                                        type: "header",
                                        settings: __assign(__assign({}, s), { type: value }),
                                    }, currentComponent: {
                                        id: settings.target,
                                        type: "header",
                                        settings: __assign(__assign({}, s), { type: value }),
                                    } }));
                            } }, { children: headerTypes &&
                                headerTypes.map(function (item, key) { return (_jsx(Option, __assign({ value: item.type }, { children: item.label }), key)); }) }))] })), _jsxs("div", __assign({ className: "mb-4" }, { children: [_jsx("label", __assign({ className: "block mb-2 font-bold text-gray-700 text-md" }, { children: "Contenu" })), _jsx(Input, { id: "content", className: "w-full px-3 py-2 border border-gray-300 text-md", type: "text", size: "sm", defaultValue: content, onChange: function (event) {
                                editedSettings(__assign(__assign({}, settings), { component: {
                                        settings: __assign(__assign({}, settings.component.settings), { content: event.target.value }),
                                    }, currentComponent: __assign(__assign({}, current), { settings: __assign(__assign({}, s), { content: event.target.value }) }), isDirty: true, newLayout: settings.newLayout }));
                            } })] })), _jsx(Spacing, {}), _jsx(Color, {})] }) }));
}
layoutComponentsDictionary.registerLayoutComponent("header-settings", HeaderSettings);
